import React, { useEffect, useState } from 'react'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import { debounce } from 'lodash-es'
import * as orderApi from '@api/order'
import InputSearch from '@shared/InputSearch/InputSearch'
import * as S from './ModalAddressSelect.styled'
import { AddressContainer } from './ModalAddressSelect.styled'
import { useChangeDelivery, useShipment } from '@entities/shipment/model'
import { useToggleAddressSelector } from 'src/features/shipment-selector/hooks'
import { CitySectionCbDesktop } from '@entities/shipment/ui/city-section-cb-desktop'

const updateAddresses = debounce(async (cityId, termText, setAddressList) => {
    if (termText) {
        const addresses = await orderApi.getAddresses(cityId, termText)
        setAddressList([...addresses])
    }
}, 250)

const ModalAddressSelect = () => {
    const shipment = useShipment()
    const changeDelivery = useChangeDelivery()
    const toggleAddressSelector = useToggleAddressSelector()
    const [selectedGeneralAddress, setSelectedGeneralAddress] = useState({
        id: 0,
        title: '',
        cityId: 0
    })
    const [selectedAddress, setSelectedAddress] = useState({
        id: 0,
        title: '',
        cityId: 0
    })
    const [addressList, setAddressList] = useState([])
    const changeTextAddressHandler = (e) => {
        const term = e.target.value
        setSelectedAddress({
            id: 0,
            title: term,
            cityId: selectedAddress.cityId
        })
        updateAddresses(selectedGeneralAddress.cityId, term, setAddressList)
    }

    const selectItemHandler = (e) => {
        const id = parseInt(e.target.id, 10)
        const selectAddress = addressList.find((x) => x.id === id)
        const text = id === -1 ? `${e.currentTarget.textContent}, ` : selectAddress.text
        setSelectedAddress({
            id,
            title: text,
            cityId: selectAddress.cityId
        })
        updateAddresses(selectedGeneralAddress.cityId, text, setAddressList)
        if (id !== -1) {
            setSelectedGeneralAddress({
                id,
                title: text,
                cityId: selectAddress.cityId
            })
        }
    }

    const changeAddressHandler = () => {
        if (selectedGeneralAddress.id !== -1)
            changeDelivery({
                shipAddressId: selectedGeneralAddress.id,
                shipAddressTitle: selectedGeneralAddress.title,
                cityId: selectedGeneralAddress.id,
                shipAddressCityId: selectedGeneralAddress.cityId
            })
    }

    useEffect(() => {
        setSelectedGeneralAddress({
            ...selectedGeneralAddress,
            cityId: shipment.cityId
        })
        if (!shipment.shipAddressId) return
        const initShipAddress = async (id) => {
            const responseAddress = await orderApi.getAddressById(id)
            if (responseAddress && responseAddress.address)
                setSelectedGeneralAddress({
                    id: responseAddress.id,
                    title: responseAddress.address,
                    cityId: responseAddress.cityId
                })
        }
        if (shipment.shipAddressId && shipment.shipAddressTitle) {
            setSelectedGeneralAddress({
                id: shipment.shipAddressId,
                title: shipment.shipAddressTitle,
                cityId: shipment.shipAddressCityId
            })
        } else {
            // noinspection JSIgnoredPromiseFromCall
            initShipAddress(shipment.shipAddressId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shipment.shipAddressId, shipment.cityId])

    const changeCitySelected = (id) => {
        if (selectedGeneralAddress.cityId === id) return
        setSelectedGeneralAddress({
            id: 0,
            title: '',
            cityId: id
        })
        setSelectedAddress({
            id: 0,
            title: '',
            cityId: id
        })
        setAddressList([])
    }

    return (
        <ModalWindow
            title="Выбор адреса"
            cancel={{
                clickHandler: toggleAddressSelector,
                text: 'Отмена'
            }}
            submit={{
                clickHandler: changeAddressHandler,
                text: 'Выбрать'
            }}>
            <S.Container data-modal-name="address">
                <CitySectionCbDesktop change={changeCitySelected} cityId={selectedGeneralAddress.cityId} />
                <AddressContainer>
                    {selectedGeneralAddress.title && (
                        <S.SelectedAddressTitle>{selectedGeneralAddress.title}</S.SelectedAddressTitle>
                    )}
                    <InputSearch
                        inputAttrs={{
                            'data-search-type': 'address'
                        }}
                        value={selectedAddress.title}
                        changeValue={changeTextAddressHandler}
                        selectHandler={selectItemHandler}
                        items={addressList}
                        placeholder="Адрес доставки"
                    />
                </AddressContainer>
            </S.Container>
        </ModalWindow>
    )
}

export default ModalAddressSelect
